import React from "react";
import { GridCell } from "@progress/kendo-react-grid";
import "./collaborators-list.css";
import SvgIcon from "@material-ui/core/SvgIcon";

export default function cellEditCollaborators(
  edit,
  profile,
  profilesBtn,
  remove,
  dataItem,
  isOnline
) {
  return class extends GridCell {
    render() {
      let online = isOnline(this.props.dataItem)
      return (
        <td className="buttons-table-acctions">
          <div
            onClick={() => {
              edit(this.props.dataItem);
            }}
          >
            <span className="cellEditCollaborators-edit-collaborators">
              {" "}
              Editar
            </span>
            <SvgIcon className="button-sign-Icon">
              <path d="M0 0h24v24H0V0z" fill="none" />
              <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z" />
            </SvgIcon>
          </div>
          <div
            onClick={() => {
              profile(this.props.dataItem);
            }}
          >
            <span className="cellEditCollaborators-edit-collaborators btn-profiles">
              {" "}
              {profilesBtn}
            </span>
            <SvgIcon className="button-sign-Icon">
              <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z"></path>
            </SvgIcon>
          </div>
          {online ? <></> :
            <span
              className="button-signers-d delete-trash"
              onClick={() => {
                remove(this.props.dataItem);
              }}
            >
              <i className="k-icon k-i-delete k-i-trash"></i>
            </span>
          }
        </td>
      );
    }
  };
}
